export interface User {
  id: number;
  slug?: string;
  uuid?: string;
  name?: string;
  username: string;
  firstName?: string;
  lastName?: string;
  gender?: string;
  dob?: Date;
  phoneNumber?: string;
  email: string;
  active: boolean;
  role: string;
  accountType: AccountType;
  accountTypeId?: number;
  primaryAccountType?: AccountType;
  primaryRole?: string;
  activeContext?: AccountContext;
  availableContexts?: AccountContext[];
  councilRole?: { id: number; name: string; slug: string; protectedReadOnly?: boolean } | null;
  permissions?: string[];
  staffMembership?: CrcStaffMembership | null;
}

export interface CrcStaffMembership {
  id: number;
  crc_id: number;
  role: string;
  status: 'active' | 'suspended' | 'ended';
  starts_at?: string | null;
  ends_at?: string | null;
  division_ids: number[];
  divisions?: any[];
  zones?: Array<{ id: number; name?: string }>;
}

export interface AccountContext {
  type: 'council' | 'crc';
  id: number;
  name: string;
  role: string;
  internal?: boolean;
}

export enum AccountType {
  SUPER_ADMIN = 'super-admin',
  COUNCIL = 'council',
  CRC = 'crc'
}
